export default "__VITE_ASSET__2c52ce53__"